import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { GroupTitleProperties } from '../Models/GroupTitleProperties';

@Injectable({
  providedIn: 'root'
})
export class GroupTitleService {

  baseUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  

  DeleteGroupTitle(groupTitleId): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/GroupTitle/DeleteGroupTitle' + '/' + groupTitleId, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  EditGroupTitle(groupTitleObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/GroupTitle/EditGroupTitle', groupTitleObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateGroupTitle(groupTitleObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/GroupTitle/CreateGroupTitle', groupTitleObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAllGroupTitle(): Observable<GroupTitleProperties[]> {
    return this.http.get<GroupTitleProperties[]>(this.baseUrl + '/GroupTitle/GetAllGroupTitle', this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  //GetGroupImage(groupTitleString1: string): Observable<string> {
  //  return this.http.get<string>(this.baseUrl + '/GroupTitle/GetGroupImage1' + '/' + groupTitleString1, this.httpOptions)
  //    .pipe(map((data: any) => {
  //      return data;
  //    }), catchError(error => { return throwError(error); }))
  //}


  GetGroupImage(groupTitleString1: string): Observable<string> {
    return this.http.get<string>(this.baseUrl + '/GroupTitle/GetGroupImage1/' + groupTitleString1).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
}
